export default __webpack_public_path__ + "static/media/footer_map.89ca1344.png";